const UNIT = 8;
const Base = {
  /** Base = 8 */
  unit: UNIT,
  none: 0,
  /** Base / 2 = 4 */
  extraSmall: UNIT / 2,
  /** Base = 8 */
  small: UNIT,
  /** Base * 2 = 16 */
  medium: UNIT * 2,
  /** Base * 4 = 32 */
  large: UNIT * 4,
  /** Base * 5 = 40 */
  extraLarge: UNIT * 5,
};

type UnitSpecificSpacing = { [key in keyof typeof Base]: string };

export const Spacing = {
  /** All the base spacing values set for px */
  px: Object.entries(Base).reduce((acc, [key, value]) => {
    acc[key] = `${value}px`;
    return acc;
  }, Object.create({})) as UnitSpecificSpacing,
  ...Base,
  /**
   * The standard or "normal" spacing.
   * A component might have a different "normal" spacing.
   * This is just the generic default spacing.
   */
  normal: Base.small,
};
